export class VinFull {
    vin!: string;
    cvvgDate!: Date;
    factoryWarrantyEndDate: Date | null = null;
    idVinCategoryVersion!: number;
}